import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import * as moment from "moment";
import { Reminders } from "../../case";
import { ActivatedRoute, Router } from "@angular/router";
import { CasesService } from "../../cases.service";
import { StorageService } from "app/main/module/common/service/storage.service";
import { fuseAnimations } from "@fuse/animations";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
    selector: "app-reminder-history-details",
    templateUrl: "./reminder-history-details.component.html",
    styleUrls: ["./reminder-history-details.component.scss"],
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None,
})
export class ReminderHistoryDetailsComponent implements OnInit {
    reminderData: Reminders[] = [];
    isLoading: Boolean = false;
    hasFirstDataShown: Boolean = false;

    constructor(
        private router: Router,
        public caseService: CasesService,
        private route: ActivatedRoute,
        private userService: StorageService,
        private snackbar : MatSnackBar
    ) {}

    ngOnInit(): void {
        const id = this.route.snapshot.queryParamMap.get("reminder_id");
        this.getSingleReminder(id);
        // console.log(this.reminderData);
    }

    getSingleReminder(id) {
        this.isLoading = true;
        this.caseService.getSingleReminderHistory(id).subscribe(
            (res: any) => {
                if (res && res.data) {
                    this.reminderData = res.data;
                    // console.log(this.reminderData);

                    this.hasFirstDataShown = true;
                    this.isLoading = false;
                } else {
                    this.reminderData = [];
                }
            },
            (error) => {
                console.error("Error fetching cases:", error);
                this.isLoading = false;
                this.openSnackBar("No Data Found","Ok")
            }
        );
    }

    back() {
        this.router.navigate(["/cases/reminder-history"]);
    }

    updateDate(value: string): string {
        if (!value || value.trim() === "") return "-";

        const tz = moment.tz.zone(this.userService.getCookie("defaultTz"))
            ? this.userService.getCookie("defaultTz")
            : "UTC";

        let m = moment(value);
        if (!m.isValid() && /^\d+$/.test(value)) {
            m = moment(Number(value));
        }

        return m.isValid() ? m.tz(tz).format("DD-MM-YYYY | HH:mm") : "-";
    }
     openSnackBar(message: string, action: string): void {
        // this.isLoading = true;
        // this.hasFirstDataShown = true;
        this.snackbar.open(message, action, {
            duration: 1000,
        });
    }
}
